/* eslint-disable */

import { allowedAny } from '@/store/interfaces/generic';
import { AxiosResponse } from 'axios';
import copyObj from '../copyObj';
import { http } from '@/util/HTTP';
import Pagination from './paginationClass';

type tPagination = {
  per_page: number; page: number; count: number
}

export default class HttpComponentRequest<T> {
  public paginationData: tPagination = {
    page: 0,
    per_page: 25,
    count: 0,
  };

  selectData: T[] = []
  exactSelectDataCopy: T[] = []
  alreadyHaveAll = false;
  page = 0;

  constructor(private key: string = '') {
    this.key = key;
  }

  async getHttpRequest(urlCallback: string, query?: string | null): Promise<void> {
    if (query) {
      await this.getHttpRequestSearching(urlCallback, query);
    } else {
      await this.getHttpRequestWithPagination(urlCallback);
    }
  }

  private async getHttpRequestWithPagination(urlCallback: string): Promise<void> {
    if (!this.alreadyHaveAll) {
      try {
        this.selectData = [];
        const res: AxiosResponse = await http.get(
          `${urlCallback}?${this.calculatePagination()}&&sort=created_at`
        ).then();
        const data = [...this.exactSelectDataCopy, ...res.data.data];
        this.paginationData = res.data.meta.pagination;
        this.selectData = this.removeDuplicateObject(data);

        this.isAlreadyForLetRequest(res);
      } catch (error) {
        console.warn(error);
      }
    }
  }

  private async getHttpRequestSearching(urlCallback: string, query: string): Promise<void> {
    this.selectData = [];
    try {
      const res: AxiosResponse = await http.get(
        `${urlCallback}?&sort=created_at&${this.key}=${query}`
      );
      this.selectData = [...res.data.data];
    } catch (error) {
      console.warn(error);
    }
    this.alreadyHaveAll = false;
    this.page = 0;
  }

  private calculatePagination(): string {
    const calculatePagination = copyObj(this.paginationData);
    this.page++;
    calculatePagination.page = this.page;

    return new Pagination(
      calculatePagination,
      '',
      []
    ).toQueryString();
  }

  private isAlreadyForLetRequest(res: AxiosResponse): void {
    if (res.data.data.length === 0 ||
      (this.paginationData.count > 0 && this.paginationData.count === this.selectData.length)) {
      this.alreadyHaveAll = true;
    } else {
      this.exactSelectDataCopy = [...this.exactSelectDataCopy, ...res.data.data];
    }
  }

  private removeDuplicateObject(data: T[]): T[] {
    const seen = new Set();
    return data.filter((el: allowedAny) => {
      const duplicate = seen.has(el.id);
      seen.add(el.id);
      return !duplicate;
    });
  }

  get getData(): T[] {
    return this.selectData;
  }

  get getPagination(): tPagination {
    return this.paginationData;
  }
}
